module.exports = __webpack_public_path__ + "static/media/bus.58f79b04.png";